'use strict';
var $ = require('../internals/export');
var f16round = require('../internals/math-f16round');

// `Math.f16round` method
// https://github.com/tc39/proposal-float16array
$({ target: 'Math', stat: true }, { f16round: f16round });



//////////////////
// WEBPACK FOOTER
// E:/Websites/eco-pest-group/app/public/wp-content/themes/pestaid-v2-4/node_modules/core-js/modules/esnext.math.f16round.js
// module id = 757
// module chunks = 0